const LINE_ITEM_FIELD_PREFIX = 'lineItem.';

export const isFieldVisible = (
  fieldName,
  refundModalType,
  customPaymentType,
) => {
  const fieldConfig = customPaymentType?.createRefundConfig;

  const field = fieldConfig?.find((config) => config.field === fieldName);
  return field?.isVisible?.[refundModalType] || false;
};

export const getFieldName = (fieldName, customPaymentType) => {
  const fieldConfig = customPaymentType?.createRefundConfig;
  const field = fieldConfig?.find((config) => config.field === fieldName);
  return field?.name || '';
};

export const getFieldLabel = (baseLabel, fieldName, customPaymentType) => {
  const configName = getFieldName(fieldName, customPaymentType);
  return configName ? `${baseLabel} (${configName})` : baseLabel;
};

export const getFieldAutoFill = (fieldName, customPaymentType) => {
  const fieldConfig = customPaymentType?.createRefundConfig;
  const field = fieldConfig?.find((config) => config.field === fieldName);
  return field?.autoFill;
};

const snakeToCamel = (str) =>
  str.replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase());

export { snakeToCamel };

export const getAutoFillDefaults = (customPaymentType, scope) => {
  const defaults = {};
  const config = customPaymentType?.createRefundConfig || [];
  config.forEach((item) => {
    if (item.autoFill?.type !== 'default' || !item.field) return;
    const isLineItem = item.field.startsWith(LINE_ITEM_FIELD_PREFIX);
    if (scope === 'lineItem' && isLineItem) {
      const key = item.field.slice(LINE_ITEM_FIELD_PREFIX.length);
      defaults[key] = item.autoFill.defaultValue ?? '';
    } else if (scope === 'topLevel' && !isLineItem) {
      defaults[snakeToCamel(item.field)] = item.autoFill.defaultValue ?? '';
    }
  });
  return defaults;
};
